/*
 * @Description:专家改造系列接口
 * @Author: 钱磊
 * @Date: 2022-07-28 08:58:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-24 17:21:53
 */
import request from '../request.js'

// 获取专家库用途（码表）-----赵建强
export const getDictsByParent = function (data) {
  return request({
      url: 'ngsExpert/getDictsByParent',
      method: 'post',
      data
  })
}

// 新增修改专家库 -----赵建强
export const saveLibInfo = function (data) {
  return request({
      url: 'ngsExpert/saveLibInfo',
      method: 'post',
      data
  })
}

// 应用库管理-查询专家库 -----赵建强
export const getLibList = function (data) {
  return request({
      url: 'ngsExpert/getLibList',
      method: 'post',
      data
  })
}

// 应用库管理-查询专家库基础信息 -----赵建强
export const getLibInfo = function (data) {
  return request({
      url: 'ngsExpert/getLibInfo',
      method: 'post',
      data
  })
}

// 修改专家及专家库状态 -----赵建强
export const changeStatus = function (data) {
  return request({
      url: 'ngsExpert/changeStatus',
      method: 'post',
      data
  })
}

// 专家基础库列表查询 -----叶凡
export const getBaseExpertList = function (data) {
  return request({
      url: 'ngsExpert/getBaseExperts',
      method: 'post',
      data
  })
}

// 专家应用库列表查询 -----叶凡
export const getLibExpertList = function (data) {
  return request({
      url: 'ngsExpert/getLibExperts',
      method: 'post',
      data
  })
}

// 查询专家详情 -----赵建强
export const getExpertDetail = function (data) {
  return request({
      url: 'ngsZjps/getExpert',
      method: 'post',
      data
  })
}

// 应用库管理-归属单位查询 -----赵建强
export const getLibUnitList = function (data) {
  return request({
      url: 'ngsExpert/getLibUnitList',
      method: 'post',
      data
  })
}

// 运营专家应用库管理-归属单位查询 -----赵建强
export const getTenantsForExpert = function (data) {
  return request({
      url: 'userTenantCenter/getTenantsForExpert',
      method: 'post',
      data
  })
}

// 应用库管理-归属单位保存 -----赵建强
export const saveLibUnit = function (data) {
  return request({
      url: 'ngsExpert/saveLibUnit',
      method: 'post',
      data
  })
}

// 应用库管理-查询专家专业类别 -----赵建强
export const getSpecialtyList = function (data) {
  return request({
      url: 'ngsExpert/getSpecialtyList',
      method: 'post',
      data
  })
}

// 删除专家专业类别(查询是否可以删除) -----赵建强
export const delSpecialty = function (data) {
  return request({
      url: 'ngsExpert/delSpecialty',
      method: 'post',
      data
  })
}

// 专家专业类别新增、修改 -----赵建强
export const saveSpecialty = function (data) {
  return request({
      url: 'ngsExpert/saveSpecialty',
      method: 'post',
      data
  })
}

// 应用库管理-查询变更记录 -----赵建强
export const getLibChanges = function (data) {
  return request({
      url: 'ngsExpert/getLibChanges',
      method: 'post',
      data
  })
}

// 应用库管理-查询专家基础库状态 -----赵建强
export const getBaseStatus = function (data) {
  return request({
      url: 'ngsExpert/getBaseStatus',
      method: 'post',
      data
  })
}